import { inject, Injectable } from '@angular/core';
import { GoogleEncryptionService } from '../../api-repos/google-encryption/google-encryption.api.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class UtilitiesService {
	googleEncryptionService = inject(GoogleEncryptionService);

	decrypt(encrypted: string): Promise<string> {
		return firstValueFrom(this.googleEncryptionService.decrypt(encrypted));
	}
}
